import { render } from "./menu-items.vue?vue&type=template&id=5f586dd2"
import script from "./menu-items.vue?vue&type=script&lang=js"
export * from "./menu-items.vue?vue&type=script&lang=js"

import "./menu-items.vue?vue&type=style&index=0&id=5f586dd2&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__